import { BuyProductsModal } from "./BuyProducts.model";
import { Promoreturnmodal } from "./PromoReturn.model";

export class BuyIpsProductReturn {
     products :BuyProductsModal[];
     discount :Promoreturnmodal;
}
